import App from './App.svelte';

/** Init Component */
let readingbar = window.FAB_PLUGIN.to_display.find( e => 'readingbar' === e.type );
if(readingbar){
	/** Init DOM */
	let dom = `<div id="fab-readingbar-container" class="fab-container"></div>`;
	if(readingbar.module.options.target.value === 'body'){ jQuery('body').prepend(dom); }
	else { jQuery( readingbar.module.options.target.value ).append(dom); }
}

/** ReadingBar Component */
const app = (readingbar) ? new App({
	target: document.querySelector("#fab-readingbar-container"),
	props: { readingbar }
}) : false;

export default app;